import { useCheckRole } from '@ospace/auth'
import { CampaignLayout, useCampaign } from '@ospace/campaign'
import { userTypes } from '@ospace/core-auth'
import { createObjectiveResultSchema, ObjectiveResult } from '@ospace/schemas/objective'
import { showNotification } from '@ospace/shared'
import { Formik } from 'formik'
import React from 'react'
import { Loader } from '@mantine/core'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import { inits } from '../components/CreateObjectiveHelper'
import { ObjectiveForm } from '../components/ObjectiveForm'
import { ObjectiveService } from '../services'

const CreateObjectiveResultPage: React.FC = () => {
  useCheckRole([userTypes.Admin, userTypes.ClientManager, userTypes.CampaignManager])
  const queryClient = useQueryClient()
  const params: any = useParams()
  const navigate = useNavigate()

  const campaignId = Number(params?.id)
  const { status, data: campaign, error } = useCampaign(campaignId)
  const mutation = useMutation(
    (objective: ObjectiveResult) => {
      const objectResultDTO = {
        ...objective,
        objective: campaign?.objective?.id,
        campaign: {
          name: campaign?.name,
          crm: campaign?.crm,
          id: campaign?.id,
        },
        client: {
          id: campaign?.client?.id,
          name: campaign?.client?.name,
        },
      }
      return ObjectiveService.createObjectiveResult(objectResultDTO)
    },
    {
      onSuccess: () => {
        showNotification({
          message: 'You have successfully updated the campaign.',
          type: 'success',
        })
        queryClient.invalidateQueries('campaigns')
        queryClient.invalidateQueries('campaign')
      },
    }
  )

  return (
    <CampaignLayout>
      {status === 'loading' || status === 'idle' ? (
        <div
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '60vh' }}
        >
          <Loader color='blue' />
        </div>
      ) : status === 'error' ? (
        <span>Error: {(error as any).message}</span>
      ) : (
        <>
          <div className='card'>
            <Formik
              initialValues={inits}
              validationSchema={createObjectiveResultSchema}
              onSubmit={async (values, actions) => {
                await mutation.mutateAsync(values as any)
                actions.resetForm()
                navigate(-1)
              }}
            >
              {() => (
                <ObjectiveForm
                  mutation={mutation}
                  campaign={campaign}
                  backLink={`/campaign/view/${campaign?.id}`}
                />
              )}
            </Formik>
          </div>
        </>
      )}
    </CampaignLayout>
  )
}

export { CreateObjectiveResultPage }
